import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddUnit from "./AddUnit";
import DeleteUnit from "./DeleteUnit";
import EditUnit from "./EditUnit";
import ReactPaginate from "react-paginate";
import UnitViewModel from "../Unit/UnitViewModel";
var dateFormat = require("dateformat");
class Unit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUnitAddModel: false,
      showUnitDelModel: false,
      UnitViewShow: false,
      showUnitEditModel: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.fetchUnitlist();
  }
  handleAddUnit = () => {
    this.setState({
      showUnitAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showUnitAddModel: false,
    });
  };
  handleDelUnit = (item) => {
    this.setState({
      showUnitDelModel: true,
      DeleteUnitItem: item,
    });
  };
  closeUnitDelModel = () => {
    this.setState({
      showUnitDelModel: false,
    });
  };
  handleUnitView = (item) => {
    // console.log(item);
    this.setState({
      UnitViewShow: true,
      UnitViewDtls: item,
    });
  };

  handleCloseUnit = () => {
    this.setState({ UnitViewShow: false });
  };
  handleEditUnit = (item) => {
    this.setState({
      showUnitEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showUnitEditModel: false,
    });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.unitSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.UnitCount && this.props.UnitCount;
    let unitPageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Units</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddUnit()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddUnit
                showUnitAddModel={this.state.showUnitAddModel}
                closeAddModel={this.closeAddModel}
                AddUnit={this.props.AddUnit}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>Basic Unit</th>
                    <th>NAME</th>
                    <th>Description</th>
                    <th>Symbol</th>
                    <th>ACTIVE</th>
                    <th>CREATED DATE</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.UnitList &&
                    this.props.UnitList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {" "}
                          {item !== null && item.unit}
                        </td>
                        <td className="cmn_Cap ">
                          {" "}
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {" "}
                          {item !== null && item.desc}
                        </td>
                        <td className="cmn_Cap">
                          {" "}
                          {item !== null && item.symbol}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.isActive ? "Yes" : "No"}
                        </td>
                        <td className="cmn_Cap">
                          {" "}
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleUnitView({
                                  item: item,
                                })
                              }
                            ></i>
                            <UnitViewModel
                              show={this.state.UnitViewShow}
                              handleClose={this.handleCloseUnit}
                              UnitViewDtls={this.state.UnitViewDtls}
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditUnit(item)}
                            ></i>
                            <EditUnit
                              showUnitEditModel={this.state.showUnitEditModel}
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditUnit={this.props.EditUnit}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelUnit(item)}
                            ></i>
                            <DeleteUnit
                              showUnitDelModel={this.state.showUnitDelModel}
                              closeUnitDelModel={this.closeUnitDelModel}
                              DeleteUnitItem={this.state.DeleteUnitItem}
                              DeleteUnit={this.props.DeleteUnit}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
            {(this.props.UnitList === undefined ||
              (this.props.UnitList && this.props.UnitList.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Units Found</div>
              </div>
            )}
          </Card.Body>
          {unitPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={unitPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Unit;
